module.exports = __webpack_public_path__ + "img/no_camera.b1b5deee.svg";